import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 h-100 d-flex justify-content-center align-items-center" }

import LoadingRing from "@/components/LoadingRing.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingCentralBox',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        _createVNode(LoadingRing)
      ])
    ])
  ]))
}
}

})